import { useState, useEffect } from 'react';
import { Portal, Select, SelectValueChangeDetails, createListCollection } from '@chakra-ui/react';
import { useMap } from '@/components/map/map-context';
import { storageManager } from '@/lib/utils/storage-manager';

interface BasemapItem {
  label: string;
  value: string;
}

const maps = createListCollection<BasemapItem>({
  items: [
    {
      label: 'Aerial',
      value: 'Aerial',
    },
    {
      label: 'Hybrid',
      value: 'Hybrid',
    },
    {
      label: 'Roads',
      value: 'Roads',
    },
    {
      label: 'Dark',
      value: 'Dark',
    },
  ],
});

export const BasemapSelection = () => {
  const { baseLayerGroup } = useMap();
  const [selectedBasemap, setSelectedBasemap] = useState<string>(() => {
    return storageManager.loadBasemap();
  });

  useEffect(() => {
    if (baseLayerGroup) {
      baseLayerGroup.getLayers().forEach((layer) => {
        const layerName = layer.get('name');
        layer.setVisible(layerName === selectedBasemap);
      });
    }
  }, [baseLayerGroup, selectedBasemap]);

  const handleChange = (details: SelectValueChangeDetails<{ label: string; value: string }>) => {
    if (details?.value && details.value.length > 0) {
      const newBasemap = details.value[0];
      setSelectedBasemap(newBasemap);
      storageManager.saveBasemap(newBasemap);
    }
  };

  return (
    <Select.Root
      size='sm'
      width='full'
      collection={maps}
      defaultValue={[selectedBasemap]}
      onValueChange={handleChange}
    >
      <Select.HiddenSelect />
      <Select.Label>Basemap:</Select.Label>
      <Select.Control>
        <Select.Trigger>
          <Select.ValueText placeholder='Select map' />
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Portal>
        <Select.Positioner style={{ zIndex: 1500 }}>
          <Select.Content>
            {maps.items.map((map) => (
              <Select.Item item={map} key={map.value}>
                {map.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>
  );
};
